var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaparrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#22A9E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9996 31.4C31.7996 32.2 32.9996 32.2 33.7996 31.4C34.5996 30.6 34.5996 29.4 33.7996 28.6L29.3996 24L33.9996 19.4C34.3996 19 34.5996 18.6 34.5996 18C34.5996 16.8 33.7996 16 32.5996 16C31.9996 16 31.5996 16.2 31.1996 16.6L25.1996 22.6C24.3996 23.4 24.3996 24.6 25.1996 25.4L30.9996 31.4ZM13.9996 25.4L19.9996 31.4C20.7996 32.2 21.9996 32.2 22.7996 31.4C23.5996 30.6 23.5996 29.4 22.7996 28.6L18.1996 24L22.7996 19.4C23.1996 19 23.3996 18.6 23.3996 18C23.3996 16.8 22.5996 16 21.3996 16C20.7996 16 20.3996 16.2 19.9996 16.6L13.9996 22.6C13.3996 23.4 13.3996 24.6 13.9996 25.4Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaparrow);
export default __webpack_public_path__ + "static/media/maparrow.1e111135b962afea4ab69c7af6b9dc00.svg";
export { ForwardRef as ReactComponent };